import { EMPTY_ARRAY_DATA } from '@common/constants';

export const flatDataValues = (data: object) => {
  return Array.isArray(data) ? EMPTY_ARRAY_DATA : Object.values(data).flat();
};
